"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HTMLBlock: {
    margin: '0',
    padding: '0',
    '& > :first-child': {
      marginTop: 0
    }
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map